import React from "react"
import { Navigate } from "react-router-dom"

// Non-Authentication related pages
// import Login from "../pages/DigitalApp/Authentication/Login"
// import Logout from "../pages/DigitalApp/Authentication/Logout"
// import Reset from "../pages/DigitalApp/Authentication/Reset"

// Non-Authentication related pages
import Logout from "../pages/Utility/logout"

// Non-Authentication related pages
import PlaceHolder from "../pages/Utility/place-holder"

// Non-Authentication related pages
import SessionTimeout from "../pages/Utility/session-timeout"

// Invalid Route
import PagesNotFound from "../pages/Utility/pages-notfound"

// Merchant Dash Board Route
import Console from "../pages/Console/dashboard"

//Digital-App - Application
 import LandingPage from "../pages/Application/landing-page"
 import PersonalInformation from "../pages/Application/personalInformation"
 import IncomeInformation from "../pages/Application/incomeInformation"
 import ResidencyInformation from "../pages/Application/residencyInformation"
 import ReferenceInformation from "../pages/Application/referenceInformation"
 import AccessCode from "../pages/Application/accessCode"
 import ValidateAccessCode from "../pages/Application/validateAccessCode"
 import AddCosigner from "../pages/Application/addCosigner"
 import ApplicationCompleted from "../pages/Utility/application-completed"
 import CustomerApplication from "../pages/Utility/customer-application"

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/application-complete", component: <ApplicationCompleted /> },
  { path: "/customer/documents/authoritative-copy/:guid", component: <CustomerApplication /> },
]

const invalidRoutes = [{ path: "*", component: <PagesNotFound /> }]

const placeholderRoutes = [  
  { path: "/console/code/:code/pin/:pin", component: <PlaceHolder /> },
  { path: "/sign-up/:identifier", component: <PlaceHolder /> },
  { path: "/sign-up/:coapplicant/:identifier", component: <PlaceHolder /> },
  { path: "/session-timeout", component: <SessionTimeout /> },
]
//
const merchantProtectedRoutes = [
  { path: "/dashboard", component: <Console /> },
]

 const authProtectedRoutes = [
  //Application
  {
    path: "/landing-page",
    component: (
      <LandingPage
        state={{
          applicantType: "applicant",
          page: "landing-page",
          step: 2,
        }}
      />
    ),
  },
  {
    path: "/co/landing-page",
    component: (
      <LandingPage
        state={{
          applicantType: "coapplicant",
          page: "co-landing-page",
          step: 2,
        }}
      />
    ),
  },
  {
    path: "/personal-information",
    component: (
      <PersonalInformation
        state={{
          applicantType: "applicant",
          page: "personal-information",
          step: 1,
        }}
      />
    ),
  },
  {
    path: "/co/personal-information",
    component: (
      <PersonalInformation
        state={{
          applicantType: "coapplicant",
          page: "co-personal-information",
          step: 1,
        }}
      />
    ),
  },
  {
    path: "/income-information",
    component: (
      <IncomeInformation
        state={{
          applicantType: "applicant",
          page: "income-information",
          step: 2,
        }}
      />
    ),
  },
  {
    path: "/co/income-information",
    component: (
      <IncomeInformation
        state={{
          applicantType: "coapplicant",
          page: "co-income-information",
          step: 1,
        }}
      />
    ),
  },
  {
    path: "/residency-information",
    component: (
      <ResidencyInformation
        state={{
          applicantType: "applicant",
          page: "residency-information",
          step: 3,
        }}
      />
    ),
  },
  {
    path: "/co/residency-information",
    component: (
      <ResidencyInformation
        state={{
          applicantType: "coapplicant",
          page: "co-residency-information",
          step: 1,
        }}
      />
    ),
  },
  {
    path: "/reference-information",
    component: (
      <ReferenceInformation
        state={{
          applicantType: "applicant",
          page: "references",
          step: 4,
        }}
      />
    ),
  },
  {
    path: "/co/reference-information",
    component: (
      <ReferenceInformation
        state={{
          applicantType: "coapplicant",
          page: "co-reference-information",
          step: 1,
        }}
      />
    ),
  },
  {
    path: "/access-code",
    component: (
      <AccessCode
        state={{
          applicantType: "applicant",
          page: "access-code",
          step: 5,
        }}
      />
    ),
  },
  {
    path: "/co/access-code",
    component: (
      <AccessCode
        state={{
          applicantType: "coapplicant",
          page: "co-access-code",
          step: 5,
        }}
      />
    ),
  },
  {
    path: "/validate-access-code",
    component: (
      <ValidateAccessCode
        state={{
          applicantType: "applicant",
          page: "validate-access-code",
          step: 6,
        }}
      />
    ),
  },
  {
    path: "/co/validate-access-code",
    component: (
      <ValidateAccessCode
        state={{
          applicantType: "coapplicant",
          page: "co-validate-access-code",
          step: 5,
        }}
      />
    ),
  },
  {
    path: "/add-cosigner",
    component: (
      <AddCosigner
        state={{
          applicantType: "applicant",
          page: "add-cosigner",
          step: 7,
        }}
      />
    ),
  },
]

export { authProtectedRoutes, invalidRoutes, placeholderRoutes, merchantProtectedRoutes, publicRoutes }
